import { ref, reactive, onBeforeMount, computed, getCurrentInstance, watch } from "@vue/composition-api";
import useTagList from '@/utils/hooks/useTagList'
import quizListModel from '@/models/survey-quiz/quiz-list'
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import router from "@/router";
import store from "@/store";

export default function usePermission(props) {
    const { fetchTagListData } = useTagList()
    const { updatePermission, fetchQuizDetailModel } = quizListModel()
    const { openErrorModal, openDefaultErrorModal } = useValidationModal();
    const vm = getCurrentInstance().proxy

    const TAG_ADD = ref(1);
    const permissionForm = reactive({
        isComplete: false,
        titleName: "",
        quizGroupId: null,
        visibility: [],
        quizzer: [],
        duplicate: "",
        numberPlayers: 1,
        selectedTag: TAG_ADD,
        headerName: "กรุณาตั้งค่าสิทธิ์การเข้าถึงแบบสำรวจ",
        usageLimit: 0,

    })

    if (router.currentRoute.query.quizGroupId) {
        permissionForm.quizGroupId = parseInt(router.currentRoute.query.quizGroupId)

    } else {
        permissionForm.quizGroupId = parseInt(router.currentRoute.params.ref)
    }

    const tagOption = reactive({
        visibilityTagOption: [],
        quizzerOption: []

    })

    const updateUsageLimit = (number) => {
        permissionForm.usageLimit = number;
    }

    const selectedTagPer = (tag) => {
        tagOption.quizzerOption = tag
        if (tagOption.quizzerOption.length != permissionForm.quizzer.length) {
            let filterQuizze = tagOption.quizzerOption.filter((e) => {
                return permissionForm.quizzer.indexOf(e) > -1;

            });
            permissionForm.quizzer = filterQuizze

        } else {
            let data = tagOption.quizzerOption.filter((o) => {
                return permissionForm.quizzer.includes(o);
            });
            permissionForm.quizzer = data;
        }
    }


    const checkDuplicateTag = (tag) => {
        if (tag) {
            permissionForm.quizzer = tagOption.quizzerOption

        } else {
            permissionForm.quizzer = ""
        }
    }

    const fetchQuizDetail = () => {
        window.$loading(true)
        fetchQuizDetailModel.payload.GroupId = permissionForm.quizGroupId;
        store
            .dispatch("api/apiFormRequest", fetchQuizDetailModel)
            .then((response) => {
                const respQuizGroup = response.data.resp.quiz_group;
                const respQuizTagQuizzer = response.data.resp.tag_quizzer_name;
                const respQuizTagVisibility = response.data.resp.tag_visibility_name;

                permissionForm.isComplete = response.data.resp.is_complete
                permissionForm.quizGroupId = respQuizGroup.quiz_groupid;
                TAG_ADD.value = respQuizGroup.permission_type
                permissionForm.numberPlayers = respQuizGroup.islimit
                permissionForm.usageLimit = respQuizGroup.limit
                permissionForm.visibility = respQuizTagVisibility
                permissionForm.quizzer = respQuizTagQuizzer
                tagOption.quizzerOption = permissionForm.visibility

            })
            .catch((err) => {
                openDefaultErrorModal(err);
            })
            .finally(() => {
                window.$loading(false);
            });
    };

    const fetchTag = () => {
        tagOption.visibilityTagOption = fetchTagListData()
    }

    const submitForm = () => {
        window.$loading(true)
        const visibility = permissionForm.visibility
        const quizzer = permissionForm.quizzer

        const arrVisibility = visibility.map((e) => ({
            Tag_Name: e,

        }))
        const arrTag_Quizzer = quizzer.map((e) => ({
            Tag_Name: e,
        }))

        updatePermission.payload.GroupId = permissionForm.quizGroupId
        updatePermission.payload.Permission_Type = TAG_ADD.value
        updatePermission.payload.IsLimit = permissionForm.numberPlayers
        updatePermission.payload.Limit = permissionForm.usageLimit
        updatePermission.payload.Tag_Quizzer = arrTag_Quizzer
        updatePermission.payload.Tag_Visibility = arrVisibility
        store
            .dispatch('api/apiRequest', updatePermission)
            .then(response => {
                nextStep()
            })
            .catch(error => {

                openDefaultErrorModal(error)
            })
            .finally(() => {
                window.$loading(false)
            })
    }

    const changeIsLimit = (e) => {
        if (!e) {
            permissionForm.usageLimit = 0
        }
    }

    const nextStep = () => {
        window.scrollToTop();
        vm.$emit("onNextStep");
    };

    onBeforeMount(() => {
        fetchTag()
        fetchQuizDetail();
    })



    return {
        permissionForm,
        tagOption,
        TAG_ADD,
        updateUsageLimit,
        submitForm,
        selectedTagPer,
        checkDuplicateTag,
        changeIsLimit,

    }
}